import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const InvalidToken = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Helmet>
        <title>Invalid Token</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          textAlign: "center",
          py: 4,
        }}
      >
        <Typography variant="h1" sx={{ fontSize: "8rem", fontWeight: "bold", color: "warning.main" }}>
          401
        </Typography>
        <Typography variant="h4" sx={{ mb: 2, fontWeight: "bold" }}>
          Invalid Token
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: "text.secondary" }}>
          The voucher token you're trying to access is invalid or has expired.
          Please check your voucher link and try again.
        </Typography>
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", justifyContent: "center" }}>
          <Button
            variant="contained"
            onClick={() => navigate("/")}
            sx={{ minWidth: 120 }}
          >
            Go Home
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate(-1)}
            sx={{ minWidth: 120 }}
          >
            Go Back
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default InvalidToken;
